export default __webpack_public_path__ + "static/media/people-3.d7a6f736.jpg";